export default {
  rigidBodyTypeTitle: 'Rigidbody Type',
  rigidBodyType: {
    notRigidBody: 'Non-rigid Body',
    notRigidBodyTip: 'No physical properties, only for image display.',
    staticRigidBody: 'Static Rigidbody',
    staticRigidBodyTip:
      'A stationary object will collide with other rigid bodies.',
    kinematicRigidBody: 'Kinematic Rigidbody',
    kinematicRigidBodyTip:
      'An object that Ignore the force and mass , moving at a set speed and acceleration ,will collide with other rigid bodies.',
    dynamicRigidBody: 'Dynamic Rigidbody',
    dynamicRigidBodyTip:
      "An object with a certain mass, moving under the action of external forces and following Newton\\'s laws of motion, will collide with other rigid bodies.",
  },
  edge: {
    title: 'Rigid Body Outline Accuracy',
    titleTip:
      'The larger the value, the higher the precision, but also the higher the performance consumption. It is recommended to choose the smallest suitable level.',
    previewBtnText: 'Preview Current Outline',
    closePreviewBtnText: 'Close Preview',
    previewAllBtnText: 'Preview All Outlines',
    previewAllBtnTip:
      'Preview all rigid body outlines to ensure that there is no overlap between bodies in the initial state. Overlapping bodies will experience physical interactions, leading to errors during gameplay.',
  },
}
